module.exports = __webpack_public_path__ + "static/media/ANAHUAC_superindependencia.658c96c4.png";